/**
 * Created by ccczzz on 2020/7/15.
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import Login from '../views/Login/login'

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'login',
        hidden: true,
        component: Login,
        meta: {
            title: '登录页'
        },
    },
    {
        path: '/',
        name: '',
        component: Home,
        children: [
            // // 个人信息
            {
                path: '/problemsList',
                name: 'problemsList',
                component:()=> import('../views/problems/problemsList.vue'),
                meta: {
                    title: '常见问题'
                }
            },
            {

                // path: '/login',
                // name: 'login',
                path: '/investmentReportList',
                name: 'investmentReportList',
                component:()=> import('../views/investmentReport/investmentReportList.vue'),
                meta: {
                    title: '投资型保险查询'
                }
            }
            // {

                // path: '/reportSurvey',
                // name: 'reportSurvey',
                // component:()=> import('../views/report/reportSurvey.vue'),
                // meta: {
                //     title: '保单概况'
                // }
            // },
            // {

                // path: '/propertyReportDetail',
                // name: 'propertyReportDetail',
                // component:()=> import('../views/report/propertyReportDetail.vue'),
                // meta: {
                //     title: '保单详情'
                // }
            // },
            // {

                // path: '/personalReportDetail',
                // name: 'personalReportDetail',
                // component:()=> import('../views/report/personalReportDetail.vue'),
                // meta: {
                //     title: '保单详情'
                // }
            // },
            // {
                // path: '/reportSearch',
                // name: 'reportSearch',
                // component:()=> import('../views/report/reportSearch.vue'),
                // meta: {
                //     title: '保单查询'
                // }
            // },
            // {
                // path:'/taxAdvantageDetail',
                // name:'taxAdvantageDetail',
                // component:()=> import('../views/report/taxAdvantageDetail.vue'),
                // meta:
                // {
                //     title: '税优详情'
                // }
            // },
            // {
                // path:'/taxDeferralDetail',
                // name:'taxDeferralDetail',
                // component:()=> import('../views/report/taxDeferralDetail.vue'),
                // meta:
                // {
                //     title: '税延详情'
                // }
            // }
        ]
    },
]

const router = new VueRouter({
    mode: 'history',
    // base:'admin',
    routes

});
router.beforeEach((to,from,next) => {
    var logined=sessionStorage.getItem('logined');
    if(logined=='1'||to.name=='login'||to.name=='problemsList'){
       next()
   }else{
       next({
           name:'login',
           query:{
           }
       })
   }
});
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});
export default router
